import { useState } from "react";
import { IonButton, IonModal, IonToggle } from "@ionic/react";
import msg from "components/string-table";
import { Colors, Icon } from "main";

import styles from "./AliasBanner.module.css";

type AliasBannerProps = {
  email: string;
  isAdmin?: boolean;
};

export function AliasBanner(props: AliasBannerProps) {
  const { email, isAdmin } = props;
  const storedValue = JSON.parse(localStorage.getItem("swing-view-as-admin") || "false");
  const [isOpen, setIsOpen] = useState(false);

  const onCheckboxChange = (e: CustomEvent) => {
    const newVal = e.detail.checked;
    localStorage.setItem("swing-view-as-admin", JSON.stringify(newVal));
    location.reload();
  };

  return (
    <div role="complementary" className={styles["alias-banner-container"]}>
      <div
        css={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div css={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
          <Icon name="Eye Glasses" color={Colors.white200} />
          <span className={`${styles["alias-banner-label"]} ${styles["alias-truncate"]}`}>
            {msg("LABEL_ALIASED")}: {email}
          </span>
        </div>
        {isAdmin && (
          <div css={{ display: "flex", alignItems: "center", gap: "4px", cursor: "pointer" }}>
            <div onClick={() => setIsOpen(true)}>
              <Icon name="Help" color={Colors.white200} />
            </div>
            <span>View as admin</span>
            <IonToggle checked={storedValue} onIonChange={(e) => onCheckboxChange(e)}></IonToggle>
            <IonModal isOpen={isOpen} onIonModalDidDismiss={() => setIsOpen(false)}>
              <div css={{ padding: 20 }}>
                <div
                  css={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>View As Admin</div>
                  <IonToggle
                    checked={storedValue}
                    onIonChange={(e) => onCheckboxChange(e)}
                  ></IonToggle>
                </div>
                <p>
                  As a superadmin, you have elevated privileges and can see certain things that a
                  normal admin cannot. You are currently {storedValue ? "" : "not"} viewing this as
                  a normal admin. To see exactly what the user sees, turn the above toggle to on.
                </p>
                <IonButton onClick={() => setIsOpen(false)}>Close</IonButton>
              </div>
            </IonModal>
          </div>
        )}
      </div>
    </div>
  );
}
